import OutdatedBrowserPage from './outdatedBrowser'

export { OutdatedBrowserPage }
